import React, { useEffect, useState, useRef } from "react";
import LogoSvg from "/public/images/logos/lazyPrompts/sealTextHorizontal.svg";
import Button from "@/components/button";
import FloatingTextInput from "@/components/floating-text-input";
import Link from "next/link";
import css from "./index.module.scss";
import Router from "next/router";
import site from "/scripts/apis/site/index.js";

export default function ResetPasswordForm({ }) {
  const [cta, setCta] = useState("Reset Password");
  const [message, setMessage] = useState("");

  const [form, setForm] = useState({
    password: useRef(),
  });

  async function handleSubmit() {
    let allValid = true;
    for (const [key, element] of Object.entries(form)) {
      if (!element.current.isValid()) {
        allValid = false;
      }
    }

    if (allValid) {
      setCta("Joining");
      site.query(site.endpoints.AUTH_RESET, {
        code: Router.query.code,
        password: form.password.current.getValue().trim(),
      }).then((res) => {
        if (res.error) {
          setMessage(`Error:${JSON.stringify(res.error)}`);
          setCta("Reset Password");
        } else {
          setMessage("Success. You may now sign in with your new password.");
        }
      });
    }
  };

  return (
    <div className={`dark ${css.signInWrapper}`}>
      <div className={css.logo}>
        <LogoSvg />
      </div>

      <FloatingTextInput
        name="password"
        className={css.input}
        label="New password"
        type="password"
        ref={form.password}
        validators={[
          { test: (val) => /^$/.test(val), class: "invalid", message: "Required" },
          { test: (val) => /^.{0,7}$/.test(val), class: "invalid", message: "Must be 8+ characters" },
          { test: (val) => /^(^([^0-9])*)$/.test(val), class: "invalid", message: "Must have a number" },
          { test: (val) => /^(^([^A-Z])*)$/.test(val), class: "invalid", message: "Must have an uppercase letter" },
          { test: (val) => /^(^([^a-z])*)$/.test(val), class: "invalid", message: "Must have a lowercase letter" },
          { test: (val) => /^..*$/.test(val), class: "valid", message: "Strength: high" },
        ]}
      />
      <Button raised className={css.button} label={cta} onClick={handleSubmit} />
      <div className={css.message}>{message}</div>
      <div className={css.links}>
        <Link href="/auth/signin">Create account</Link>
        <Link href="/auth/register">Sign in</Link>
      </div>
    </div>
  );
}
